import React from "react";
import { LicensePlateVinLookupMethods } from "../../../reducers/reducer-license-plate-vin-lookup";
import { LicensePlateLookup } from "../../../components/LicensePlateLookup";
import { VinLookup } from "../../../components/VinLookup";

export type AddVehicleByLicensePlateVinProps = {
  lookupMethod: LicensePlateVinLookupMethods;
};

export const AddVehicleByLicensePlateVin = ({ lookupMethod }: AddVehicleByLicensePlateVinProps) => {
  return lookupMethod === "License Plate" ? <LicensePlateLookup /> : <VinLookup />;
};
